// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"26a8ad6e","931":"5d8554fd"}[chunkId] + ".chunk.css";
};